/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { routes } from './cabinet/cabinet.routing.module';
import { showCaseRoutes } from './cabinet/showcase.routing.module';
import { UtilsService } from './cabinet/utils/utils.service';


@NgModule({
  imports: [RouterModule.forRoot(UtilsService.isCurrentDomainShowcase() ? showCaseRoutes : routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


